let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fg7LP")).then(() => parcelRequire('baJ3W'));